module.exports = __webpack_public_path__ + "static/media/Sun.92132511.gif";